interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color = 'border-primary-yellow',
  className = '',
}) => {
  const sizeClasses = {
    small: 'w-1-0 h-1-0 border-1',
    medium: 'w-2-0 h-2-0 border-1',
    large: 'w-4-0 h-4-0 border-2',
  };

  return (
    <div className={className}>
      <div
        className={`
          animate-spin
          rounded-full
          border-solid
          border-t-transparent
          border
          ${sizeClasses[size]}
          ${color}
        `}
      />
    </div>
  );
};

export default LoadingSpinner;
